"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var UserBrowser_1 = __importDefault(require("../session/UserBrowser"));
var appenders_1 = require("./appenders");
var logger_1 = __importStar(require("./logger"));
function initialize(options) {
    logger_1.initContext(__assign({ isProduction: options.isProduction, appName: options.appName, version: options.version }, UserBrowser_1.default.get()));
    appenders_1.initialize(options.isProduction, options.appName);
}
exports.initialize = initialize;
exports.default = logger_1.default;
//# sourceMappingURL=index.js.map